<template>
  <div>
    <Form ref="runUpdateData" :rules="formRules" :model="formData" :label-width="100" :inline="true">
      <FormItem label="项目名称">
        <Input class="input-long"/>
      </FormItem>
      <br>
      <FormItem label="项目说明">
        <Input class="input-long"/>
      </FormItem>
      <br>
      <FormItem label="合作模式">
        <Select class="select-width">
          <!--<Option>请选择</Option>-->
          <!--<Option v-for=""></Option>-->
        </Select>
      </FormItem>
      <FormItem label="项目状态">
        <Select class="select-width">
          <!--<Option>请选择</Option>-->
          <!--<Option v-for=""></Option>-->
        </Select>
      </FormItem>
      <FormItem label="业主名称">
        <Select class="select-width">
          <!--<Option>请选择</Option>-->
          <!--<Option v-for=""></Option>-->
        </Select>
      </FormItem>
      <br>
      <FormItem label="结算公司名称">
        <Select class="select-long">
          <!--<Option>请选择</Option>-->
          <!--<Option v-for=""></Option>-->
        </Select>
      </FormItem>
      <br>
      <FormItem label="用水类别">
        <Input class="input-short"/>
      </FormItem>
      <FormItem label="水基价">
        <Input class="input-short"/>
      </FormItem>

      <FormItem label="用电类别">
        <Input class="input-short"/>
      </FormItem>
      <br>
      <FormItem label="电基价">
        <Input class="input-short"/>
      </FormItem>

      <FormItem label="供暖方式">
        <Select class="select-width">
          <!--<Option>请选择</Option>-->
          <!--<Option v-for=""></Option>-->
        </Select>
      </FormItem>

      <FormItem label="车位数">
        <Input class="input-short"/>
      </FormItem>
      <br>
      <FormItem label="开业日期">
        <!--<Input/>-->
      </FormItem>
      <br>
      <FormItem label="项目描述">
        <Input type="textarea"/>
      </FormItem>
      <br>
      <FormItem label="备注">
        <Input class="input-long"/>
      </FormItem>
    </Form>
    <save-and-cancel @save="save" @cancel="cancel">
    </save-and-cancel>
  </div>
</template>

<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'

  export default {
    name: "RunAdd",
    components: {
      SaveAndCancel,
    },
    data() {
      return {
        formData: {},
        formRules: {}
      }

    },
    methods: {
      save() {

      },
      cancel() {

      }
    }
  }
</script>

<style scoped>
  .input-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .select-long {
    width: 200px;
  }

  .input-short {
    width: 100px;
  }

</style>
